import axios from "axios";
import { baseURL, client } from "./api";

let config = {
  baseURL,
};
function formatDateTo(date) {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(date).toLocaleDateString('en-US', options);
}
export const addStockData = async (payload) => {
  return await client.post("stock/addStock", payload);
};

export const getEntriesExits = async () => {
  return await client.get("stock/getEntriesExits");
};

export const getStockDetails = async (campaignId,startDate="01/01/2000",endDate=formatDateTo(new Date())) => {
  return await client.get(`stock/getStock?campaignId=${campaignId}&startDate=${startDate}&endDate=${endDate}`);
}
export const getStockPdf = async (campaignId,startDate="01/01/2000",endDate=formatDateTo(new Date())) => {
  return await client.get(`report-pdf/stock-sheet?campaignId=${campaignId}&startDate=${startDate}&endDate=${endDate}`);
}
export const getSeed = async () => {
  return await client.get(`seed/getSeed`);
}

export const getStockReport = async () => {
  return await client.get("stock/stockReport");
};

export const getSingleStock = async (stockId) => {
  return await client.get("stock/getSingleStock", { params: stockId });
};
export const getFilterStock = async (filterParams) => {
  return await client.get("stock/getFilterStock", { params: filterParams }); // farmId=1&filterDate=01/25/2022
};

export const getFilterStockByType = async (filterParams) => {
  return await client.get("stock/getFilterStockByType", { params: filterParams }); // farmId=1&filterDate=01/25/2022
};

export const editStockData = async (payload) => {
  console.log(payload,'******* payload Data register')
  return await client.put("stock/updateStock", payload);
}

export const deleteStockData = async (id) => {
  return await client.delete("stock/deleteStock");
}
